!function($) {


  var updateAddToCartState = function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
        
        $('.variant-sku').text(variant.sku);
      } else {        
        $('.variant-sku').empty();
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
  };

}(jQuery);

/* --- Event Logic to manage events and subscriptions Added By Skup Team: Dec 10, 2024 --- */
Station.Theme.Events = Station.Theme.Events || {
    events: {},

    // Subscribe to an event
    on: function (eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    },

    // Publish (emit) an event
    emit: function (eventName, data) {
        const eventCallbacks = this.events[eventName];
        if (eventCallbacks) {
            eventCallbacks.forEach(callback => callback(data));
        }
    },

    // Unsubscribe from an event
    off: function (eventName, callback) {
        const eventCallbacks = this.events[eventName];
        if (eventCallbacks) {
            this.events[eventName] = eventCallbacks.filter(cb => cb !== callback);
        }
    }
};

